import { Shield } from 'lucide-react';
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useVisualViewportHeight } from './hook.js';

export const PrivacyPolicy = () => {
    const vvHeight = useVisualViewportHeight();
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);

    const privacyPolicyList = [
        {
            header: "収集する情報",
            text: "当社は、サービス提供のために以下の情報を収集します。",
            points: [
                "メールアドレス",
                "パスワード（メール登録の場合）",
                "Googleアカウントから取得する基本情報（氏名、メールアドレス 等）",
                "決済に関する情報（Stripeを通じて処理されます）",
                "IPアドレス、ブラウザ情報、利用状況等の技術情報"
            ],
        },
        {
            header: "利用目的",
            text: "収集した情報は、以下の目的でのみ利用します。",
            points: [
                "アカウントの認証および管理",
                "領収書や決済通知の送信",
                "サービスに関する重要なお知らせの送信",
                "本サービスの運営・改善", 
                "広告効果の測定"
            ],
        },
        {
            header: "クッキー（Cookie）およびアクセス解析について",
            text: "当社は、サービスの利便性向上や利用状況の把握のために、クッキー（Cookie）および類似の技術を使用する場合があります。",
            points: [
                "クッキーは、お客様のブラウザに保存される小さなファイルであり、個人を特定するものではありません。",
                "お客様は、ブラウザの設定によりクッキーを無効化することができます。ただし、その場合、一部の機能が正しく利用できない可能性があります。",
                "当社は、Google LLC が提供する Google Analytics 等の外部サービスを利用してアクセス解析を行う場合があります。これにより収集されたデータは、サービス改善や利用状況の分析にのみ使用されます。Google によるデータの取扱いについては、Google のプライバシーポリシーをご参照ください。",
                "当社は、広告効果の測定および広告配信の最適化のために、Meta Platforms, Inc. が提供するツール（Metaピクセル等）を使用する場合があります。Meta によるデータの取扱いについては、Meta のプライバシーポリシーをご参照ください。",
            ],
        },
        {
            header: "第三者提供",
            text: "当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供しません。ただし、以下の場合は除きます。",
            points: [
                "決済処理のために、Stripe社（Stripe, Inc.およびその関連会社）に必要な範囲で情報を提供する場合",
                "広告効果の測定および広告配信の最適化のために、Meta Platforms, Inc. に必要な範囲で情報を提供する場合",
                "本サービスの一部機能（対話、質問への応答等）を提供するために、OpenAI, L.L.C. および Anthropic PBC に、利用者が入力した内容を送信する場合",
                "本サービスの運営のために、クラウドサービス提供者等に委託する場合"
            ],
        },
        {
            header: "国際データ転送について",
            text: "当社は、Stripe等の支払処理業者やクラウドサービス提供者との連携のため、個人情報を日本国外の国・地域に転送する場合があります。その際、適用される法令（個人情報保護法等）を遵守し、必要に応じて適切な契約または措置を講じます。",
        },
        {
            header: "保有期間",
            text: "当社は、取得した個人情報を、サービス提供および法令上必要な期間に限り保有します。お客様がアカウントを削除した場合、当社はアカウント削除の申請日から30日間、データを保有した後、安全に削除または匿名化いたします。これは、誤ってアカウントを削除した場合の復旧対応や、不正利用防止のために必要な期間です。",
        },
        {
            header: "安全管理",
            text: "当社は、個人情報を適切に管理し、漏洩・紛失・不正アクセス等の防止に努めます。",
        },
        {
            header: "開示・訂正・削除",
            text: "お客様は、ご自身の個人情報の開示、訂正、削除を請求することができます。ご希望の際は、下記窓口までご連絡ください。",
        },
        {
            header: "【お問い合わせ先】",
            text: " aome合同会社",
            contactInfo: " メールアドレス: hello@aome.co.jp"
        },
        {
            header: "法令遵守",
            text: "当社は、個人情報保護法（APPI）その他の関連法令を遵守します。",
        },
        {
            header: "変更",
            text: "当社は、本プライバシーポリシーの内容を適宜見直し、改定する場合があります。重要な変更がある場合は、本サービス上での通知またはお客様へのメール送信によりお知らせいたします。",
        },

    ]

    return (
        <div 
            className="w-full h-auto lg:h-full flex flex-col gap-8 p-2 lg:p-4 lg:pb-6"
            style={{ maxHeight: isDesktop ? '80vh' : Math.round(vvHeight * 0.8) }}
        >

            <div className="flex gap-2 items-center">
                <span className="">
                    <Shield className='text-base-text size-6' strokeWidth={1} />
                </span>
                <h1 className="text-base-text font-light text-lg w-max">
                    プライバシーポリシー
                </h1>
            </div>


            <div className="flex flex-col py-4 gap-6 h-full overflow-y-auto pr-2">
                <p className="text-base-text font-light">
                    aome合同会社（以下「当社」といいます。）は、お客様の個人情報を適切に取り扱うため、以下の方針を定めます。
                </p>
                {privacyPolicyList.map((privacyPolicy, index) => {
                    return (
                        <div className="flex flex-col gap-2" key={index}>
                            <p className="text-base-text font-normal">{privacyPolicy.header}</p>
                            <div className="text-base-text font-light">{privacyPolicy.text}
                                {privacyPolicy.contactInfo &&
                                    <p className="text-base-text font-light">{privacyPolicy.contactInfo}</p>
                                }
                            </div>
                            {privacyPolicy.points &&
                                <ul className="list-disc pl-8">
                                    {privacyPolicy.points.map((point, index) => {
                                        return (
                                            <li className="text-base-text font-light" key={index}>{point}</li>
                                        )
                                    })}
                                </ul>
                            }

                        </div>
                    )
                })}
            </div>
        </div>
    )
}